import $ from "jquery";
import Marionette from "backbone.marionette";
import moment from "moment-timezone";
import upperFirst from "lodash/upperFirst";

import { patchWithdraw } from "../views/withdraw";

import template from "../templates/components/inviteCard.jst";

export default Marionette.View.extend({
    template,

    ui: {
        card: ".invite-card",
        content: ".invite-card__content",
        loader: ".invite-cards__loader",
        withdraw: ".invite-card__withdraw",
        withdrawSuccess: ".invite-card__withdraw-success",
    },

    events: {
        "click .invite-card__withdraw-link": "onShowWithdraw",
        "click .invite-card__withdraw-yes": "onWithdraw",
        "click .invite-card__withdraw-no": "onHideWithdraw",
    },

    serializeData() {
        const json = this.model.toJSON();

        json.inviteType = upperFirst(json.position.interview_type.short);
        json.inviteTime = moment(json.time_interview).fromNow();

        return json;
    },

    onShowWithdraw(event) {
        event.preventDefault();

        this.ui.content.fadeOut(100, () => {
            this.ui.withdraw.fadeIn(100);
        });
    },

    onHideWithdraw(event) {
        event.preventDefault();

        this.ui.withdraw.fadeOut(100, () => {
            this.ui.content.fadeIn(100);
        });
    },

    onWithdraw(event) {
        event.preventDefault();

        this.ui.loader.show();

        patchWithdraw(this.model.get("id")).done(() => {
            this.ui.loader.hide();

            this.ui.withdraw.fadeOut(100, () => {
                this.ui.card.addClass("invite-card--withdrawn");
                this.ui.withdrawSuccess.fadeIn(100);

                this.model.trigger("withdraw");

                const $count = $(".js-invite-count");
                if ($count.length) {
                    const count = Number($count.first().text() || 0) - 1;
                    if (count === 0) {
                        $count.hide();
                    } else {
                        $count.text(count);
                    }
                }
            });
        });
    },
});
